import React, {useState} from "react"
import UserContext from './UserContext'

const UserContextProvider = ({children}) => {
    const [userIN, setUserIN] = useState(true);
    
    return (
        <UserContext.Provider value={{userIN, setUserIN}}>
            {children}
        </UserContext.Provider>
)
}
export default UserContextProvider;